"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAuthToken;

var _urlParse2 = _interopRequireDefault(require("url-parse"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getAuthToken(prefix) {
  var _urlParse = (0, _urlParse2["default"])(prefix || window.location.href),
      hostname = _urlParse.hostname;

  var subdomain = hostname.split('.')[0];

  var token = _jsCookie["default"].get("auth_token_".concat(subdomain)) || _jsCookie["default"].get('auth_token');

  return token;
}